import { render, staticRenderFns } from "./CaseSpineAssessment.vue?vue&type=template&id=d67acf94&scoped=true&"
import script from "./CaseSpineAssessment.vue?vue&type=script&lang=js&"
export * from "./CaseSpineAssessment.vue?vue&type=script&lang=js&"
import style0 from "./CaseSpineAssessment.vue?vue&type=style&index=0&id=d67acf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67acf94",
  null
  
)

export default component.exports